export default "<p>\n\t<b>Mail App:</b> - Coming soon in the following update.\n</p>\n";